import api from "../../../utils/api";

export const createSite = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  const res = await api.post("/sites/", payload);
  return res.data;
};

export const readSite = async (public_id) => {
  if (!public_id) throw new Error("Missing or invalid ID for site");
  const res = await api.get(`/sites/${public_id}`);
  return res.data;
};

export const readSites = async () => {
  const res = await api.get("/sites");
  return res.data;
};

export const updateSite = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  if (!payload.public_id) throw new Error("Missing or invalid ID for site");
  const res = await api.put(`/sites/${payload.public_id}`, payload);
  return res.data;
};

export const deleteSite = async (public_id) => {
  if (process.env.NODE_ENV === "development") console.log(public_id);
  if (!public_id) throw new Error("Invalid ID for site!");
  return await api.delete(`/sites/${public_id}`);
};
